// Sincronizar ESL Cloud · enriquece CTes "sem destinatário" via Data Export
import { db, auth } from '../client.js';
import { escapeHTML, DT, DATE, NUM, BRL } from '../shared.js';

const SUPABASE_URL = 'https://hbrvoairynwsliyxxgsg.supabase.co';
const SUPABASE_KEY = 'sb_publishable_a0ZR31NQNuDyXgm8uqoQ0g_DW96AQLB';

export async function viewSyncEsl($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">INTEGRAÇÃO ESL CLOUD</div>
        <h1>Sincronizar <strong>CTes Ícaro</strong></h1>
        <p class="lead">Puxa CTes da operação Binário direto da API ESL e enriquece os 81 CTes existentes — preenche "sem destinatário", peso, situação, data de entrega.</p>
      </div>
    </header>

    <div class="stats" id="sync-stats"></div>

    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>Disparar sync manual</h2></div>
        <form id="form-sync" class="form-stack">
          <div class="grid-2">
            <label>Desde<input id="sync-since" type="date" value="2026-01-01"></label>
            <label>Até<input id="sync-until" type="date" value="${new Date().toISOString().slice(0, 10)}"></label>
          </div>
          <p class="text-sm text-mute">A sync usa o Data Export REST do ESL Cloud (report 4364 — CTes emitidos) filtrado por CNPJ pagador Binário 07.384.807/*.</p>
          <button type="submit" class="btn btn-blue" id="btn-sync">→ Sincronizar agora</button>
          <div id="sync-result" style="display:none;"></div>
        </form>
      </div>
      <div class="card">
        <div class="card-head"><h2>Próxima onda · automação</h2></div>
        <ul class="clean">
          <li>Cron diário 06:00 BRT no Mac mini chama esta edge function</li>
          <li>Cobre 100% dos CTes Ícaro × Binário sem intervenção humana</li>
          <li>Triggera enriquecimento de destinatário automaticamente</li>
          <li>Alerta líder JOI se houver CTes sem NF correspondente após 48h</li>
        </ul>
        <div class="rule"></div>
        <p class="text-sm text-mute">Configure <span class="mono-inline">ESL_CLOUD_TOKEN</span> em <em>Supabase → Edge Functions → Secrets</em> para ativar sync real.</p>
      </div>
    </div>

    <div class="card mt-md">
      <div class="card-head"><h2>Histórico de syncs <span class="count" id="hist-count">…</span></h2></div>
      <div id="sync-hist"></div>
    </div>

    <div class="card mt-md">
      <div class="card-head"><h2>CTes pendentes de enriquecimento</h2></div>
      <div id="pendentes"></div>
    </div>
  `;

  // stats
  await loadStats();

  // submit
  document.getElementById('form-sync').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = document.getElementById('btn-sync');
    const result = document.getElementById('sync-result');
    btn.disabled = true; btn.textContent = '⟳ Sincronizando…';
    try {
      const { data: { session } } = await auth.auth.getSession();
      const token = session?.access_token || SUPABASE_KEY;
      const r = await fetch(`${SUPABASE_URL}/functions/v1/binario-wms-esl-sync`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY },
        body: JSON.stringify({
          since: document.getElementById('sync-since').value,
          until: document.getElementById('sync-until').value,
          trigger: 'manual',
          triggered_by: session?.user?.email || '',
        }),
      });
      const json = await r.json();
      result.style.display = 'block';
      if (json.dry_run) {
        result.className = 'msg warn';
        result.innerHTML = `
          <strong>⚠ Modo dry-run</strong><br>
          ${escapeHTML(json.message)}<br>
          <span class="mono-inline" style="font-size:11px;">${escapeHTML(json.next_step)}</span>`;
      } else if (json.ok) {
        result.className = 'msg ok';
        result.innerHTML = `
          <strong>✓ Sync concluída</strong><br>
          ${NUM(json.ctes_lidos)} CTes lidos · ${NUM(json.ctes_novos)} novos · ${NUM(json.ctes_atualizados)} atualizados · <strong>${NUM(json.destinatarios_enriquecidos)} destinatários preenchidos</strong>`;
      } else {
        result.className = 'msg err';
        result.innerHTML = `<strong>✕ Falhou:</strong> ${escapeHTML(json.error_messages?.join(' · ') || 'erro desconhecido')}`;
      }
      await loadStats();
    } catch (err) {
      result.style.display = 'block';
      result.className = 'msg err';
      result.innerHTML = `<strong>✕</strong> ${escapeHTML(err.message)}`;
    } finally {
      btn.disabled = false; btn.textContent = '→ Sincronizar agora';
    }
  });

  async function loadStats() {
    try {
      const { data: all } = await db.from('vw_fretes_enriquecidos').select('completude,sync_status,direcao_frete');
      const total = (all || []).length;
      const semDest = (all || []).filter(c => c.completude === 'sem_destinatario').length;
      const semNf = (all || []).filter(c => c.completude === 'aguardando_xml' || c.completude === 'sem_nf').length;
      const completos = (all || []).filter(c => c.completude === 'completo').length;
      const nuncaSync = (all || []).filter(c => c.sync_status === 'nunca_sincronizado').length;
      document.getElementById('sync-stats').innerHTML = `
        <div class="stat"><div class="label">Total CTes</div><div class="value">${NUM(total)}</div></div>
        <div class="stat warning"><div class="label">Sem destinatário</div><div class="value">${NUM(semDest)}</div><div class="delta">Enriquecer via ESL</div></div>
        <div class="stat warning"><div class="label">Aguardando XML</div><div class="value">${NUM(semNf)}</div><div class="delta">Cliente Binário envia</div></div>
        <div class="stat success"><div class="label">Completos</div><div class="value">${NUM(completos)}</div></div>
        <div class="stat ${nuncaSync > 0 ? 'warning' : 'success'}"><div class="label">Nunca sincronizados</div><div class="value">${NUM(nuncaSync)}</div></div>
      `;

      // histórico
      const { data: hist } = await db.from('esl_sync_run').select('*').order('started_at', { ascending: false }).limit(15);
      document.getElementById('hist-count').textContent = (hist || []).length;
      if (!hist || hist.length === 0) {
        document.getElementById('sync-hist').innerHTML = '<div class="empty">Nenhuma sync executada ainda.</div>';
      } else {
        document.getElementById('sync-hist').innerHTML = `
          <table class="tbl">
            <thead><tr><th>Quando</th><th>Período</th><th>Trigger</th><th class="num">Lidos</th><th class="num">Novos</th><th class="num">Atualizados</th><th class="num">Enriquecidos</th><th>Erros</th><th>Nota</th></tr></thead>
            <tbody>${hist.map(h => `
              <tr>
                <td class="mono text-sm">${DT(h.started_at)}</td>
                <td class="mono text-sm">${DATE(h.filtro_desde)} → ${DATE(h.filtro_ate)}</td>
                <td><span class="pill pill-mute">${escapeHTML(h.trigger_source || '—')}</span></td>
                <td class="num">${NUM(h.ctes_lidos)}</td>
                <td class="num">${NUM(h.ctes_novos)}</td>
                <td class="num">${NUM(h.ctes_atualizados)}</td>
                <td class="num strong">${NUM(h.destinatarios_enriquecidos)}</td>
                <td><span class="pill ${h.errors > 0 ? 'pill-red' : 'pill-green'}">${h.errors}</span></td>
                <td class="text-sm text-mute">${escapeHTML((h.notes || '').slice(0, 60))}</td>
              </tr>`).join('')}
            </tbody>
          </table>`;
      }

      // pendentes
      const { data: pend } = await db.from('vw_fretes_enriquecidos').select('*').eq('completude', 'sem_destinatario').limit(40);
      if (!pend || pend.length === 0) {
        document.getElementById('pendentes').innerHTML = '<div class="empty">✓ Todos os CTes têm destinatário.</div>';
      } else {
        document.getElementById('pendentes').innerHTML = `
          <p class="text-sm text-mute mb-md">${pend.length} CTes esperando enriquecimento via sync ESL.</p>
          <table class="tbl">
            <thead><tr><th>Data</th><th>CTe</th><th>Cidade</th><th class="num">Valor NF</th><th>Direção</th></tr></thead>
            <tbody>${pend.slice(0, 25).map(c => `
              <tr>
                <td class="mono text-sm">${DATE(c.data_frete)}</td>
                <td class="mono strong">${escapeHTML(c.cte_numero || '—')}</td>
                <td>${escapeHTML(c.cidade_destino || '—')}</td>
                <td class="num">${BRL(c.valor_nf)}</td>
                <td><span class="pill ${c.direcao_frete === 'inbound_para_binario_joi' ? 'pill-green' : 'pill-amber'}">${c.direcao_frete === 'inbound_para_binario_joi' ? 'IN' : 'OUT'}</span></td>
              </tr>`).join('')}
            </tbody>
          </table>
          ${pend.length > 25 ? `<p class="text-sm text-mute mt-sm">… e mais ${pend.length - 25}</p>` : ''}
        `;
      }
    } catch (e) {
      document.getElementById('sync-stats').innerHTML = `<div class="empty err">${escapeHTML(e.message)}</div>`;
    }
  }
}
